export const QR_ANALYSIS_MAX_SIZE = 480;
export const QR_SCAN_REGION_RATIO = 0.7;
export const QR_INVERT_RETRY_INTERVAL = 5;

export const getQrScanRegion = (videoWidth, videoHeight) => {
  const width = Math.max(0, Number(videoWidth) || 0);
  const height = Math.max(0, Number(videoHeight) || 0);
  const sourceSize = Math.max(
    1,
    Math.floor(Math.min(width, height) * QR_SCAN_REGION_RATIO),
  );

  return {
    sourceX: Math.max(0, Math.floor((width - sourceSize) / 2)),
    sourceY: Math.max(0, Math.floor((height - sourceSize) / 2)),
    sourceSize,
    analysisSize: Math.min(QR_ANALYSIS_MAX_SIZE, sourceSize),
  };
};

export const getJsQrInversionAttempts = (failedJsQrAttempts) =>
  (Math.max(0, Number(failedJsQrAttempts) || 0) + 1) %
    QR_INVERT_RETRY_INTERVAL ===
  0
    ? "attemptBoth"
    : "dontInvert";
